import { pickText, type LocalizedText } from '@tb/shared';
import { useLocale } from './LocaleProvider';

export function useManifestText(): (value: LocalizedText | string | undefined) => string {
  const { locale } = useLocale();
  return (value) => pickText(value, locale);
}
